/* eslint-disable global-require */
const List = () => import('./main.vue');

export default [
  {
    name: 'notas-autorizacoes-despesas',
    path: '/notas-autorizacoes-despesas',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Nota de Autorização de Despesa',
      icon: 'object-group',
      can: 'view',
      on: 'contaspagar',
      bisneto: true,
      client: 'rondo',
    },
  },
];
